import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { createBrowserRouter, Outlet } from "react-router";
import { RouterProvider } from "react-router/dom";


import RootLayout from './RootLayout'


function SelfService() {
  return (
    <div>
      <Outlet/>
    </div>
  );
}
function Public() {
  return (
    <div>
      <iframe src={process.env.REACT_APP_SELF_SERVICE_PUBLIC} style={{ border: "0", height:'100vh' }} width="100%" ></iframe>
    </div>
  );
}
function Private() {
  return (
    <div>
      <iframe src={process.env.REACT_APP_SELF_SERVICE_PRIVATE} style={{ border: "0", height:'100vh' }} width="100%" ></iframe>
    </div>
  );
}
const router = createBrowserRouter([
  {
    path: "/",
    Component: RootLayout,
    children: [
      { index: true, Component: App },
      {
        path: "self-service-portal", Component:SelfService ,
        children: [
          { path: "public", Component: Public, },
          { path: "private", Component: Private }

        ]
      },
    ]
  },
]);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>


    <RouterProvider router={router} />,
  </React.StrictMode>
);
